export default "/images/MikeDörsam.jpg?3d1e87554f46e10d8936348f079fd8ca";